/**
 * Generates new action types that follow the pattern of our data fetching actions
 * @param {string} root - the unique prefix used to generate the other actions
 */
const makeActionTypes = (root) => {
  return {
    root,
    request: `${root}_REQUEST`,
    success: `${root}_SUCCESS`,
    failure: `${root}_FAILURE`,
    delete: `${root}_DELETE`
  };
};

export const acquisitionMetricsActionTypes =
  makeActionTypes('FETCH_ACQUISITIONS_METRICS');

export const acquisitionSizeActionTypes =
  makeActionTypes('FETCH_ACQUISITIONS_SIZE');

export const addControlTelemetryActionTypes =
  makeActionTypes('ADD_CONTROL_TELEMETRY');

export const activeNodeIssuesActionTypes =
  makeActionTypes('FETCH_NODE_ACTIVE_ISSUES');

export const addScenarioCommentActionTypes =
  makeActionTypes('ADD_SCENARIO_COMMENT');

export const buildsActionTypes =
  makeActionTypes('FETCH_BUILDS');

export const cloudAcquisitionActionTypes =
  makeActionTypes('FETCH_CLOUD_ACQUISITIONS');

export const cloudAutomationBuildInfoActionTypes =
  makeActionTypes('FETCH_CLOUD_BUILD_INFO');

export const cloudAutomationBuildTimestampActionTypes =
  makeActionTypes('FETCH_CLOUD_BUILD_TIMESTAMP');

export const dispatchersActionTypes =
  makeActionTypes('FETCH_DISPATCHERS');

export const failedTestArtifactsActionTypes =
  makeActionTypes('FETCH_FAILED_TEST_ARTIFACTS');

export const fetchAnnotationsActionTypes =
  makeActionTypes('FETCH_ANNOTATIONS');

export const fetchArtifactHealthPlatformStatusesTypes =
  makeActionTypes('FETCH_ARTIFACT_HEALTH_PLATFORM_STATUSES');

export const fetchArtifactHealthApplicationStatusesTypes =
  makeActionTypes('FETCH_ARTIFACT_HEALTH_APPLICATION_STATUSES');

export const fetchAWSCostReportActionTypes =
  makeActionTypes('FETCH_COST_REPORT');

export const fetchInstallerTestExpectedActionTypes =
  makeActionTypes('FETCH_INSTALLER_TEST_EXPECTED');

export const fetchInstallerDifferencesActionTypes =
  makeActionTypes('FETCH_INSTALLER_DIFFERENCES');

export const fetchSonarDataActionTypes =
  makeActionTypes('FETCH_SONAR_DATA');

export const fetchUserConfigurationActionTypes =
  makeActionTypes('FETCH_USER_CONFIGURATION');

export const inactiveNodeIssuesActionTypes =
  makeActionTypes('FETCH_NODE_INACTIVE_ISSUES');

export const jobsActionTypes =
  makeActionTypes('FETCH_JOBS');

export const jobLabelsActionTypes =
  makeActionTypes('FETCH_JOB_LABELS');

export const jobBuildsActionTypes =
  makeActionTypes('FETCH_JOB_BUILDS');

export const jobLabelEditActionTypes =
  makeActionTypes('EDIT_JOB_LABEL');

export const jobRelationshipsActionTypes =
  makeActionTypes('FETCH_JOBRELATIONSHIPS');

export const jobScenariosActionTypes =
  makeActionTypes('FETCH_JOBSCENARIOS');

export const jiraScansActionTypes =
  makeActionTypes('FETCH_JIRA_SCANS');

export const jiraStatusActionTypes =
  makeActionTypes('FETCH_JIRA_STATUS');

export const latestImageBaselinesActionTypes =
  makeActionTypes('FETCH_LATEST_IMAGE_BASELINES');

export const metricTestNodesActionTypes =
  makeActionTypes('FETCH_METRIC_TEST_NODES');

export const metricsActionTypes =
  makeActionTypes('FETCH_METRICS');

export const nodeIssueTypesActionTypes =
  makeActionTypes('FETCH_NODE_ISSUE_TYPES');

export const nodeIssuesMarkInactiveTypes =
  makeActionTypes('MARK_NODE_ISSUES_INACTIVE');

export const notificationRequestActionTypes =
  makeActionTypes('FETCH_NOTIFICATION_REQUEST');

export const notificationRulesActionTypes =
  makeActionTypes('FETCH_NOTIFICATION_RULES');

export const notificationSubscribeActionTypes =
  makeActionTypes('FETCH_NOTIFICATION_SUBSCRIBE');

export const paramsActionTypes =
  makeActionTypes('FETCH_PARAMS');

export const removeAnnotationsActionTypes =
  makeActionTypes('REMOVE_ANNOTATIONS');

export const scenariosActionTypes =
  makeActionTypes('FETCH_SCENARIOS');

export const setArtifactsInfoTypes =
  makeActionTypes('SET_ARTIFACTS_INFO');

export const searchExceptionsByTermActionTypes =
  makeActionTypes('SEARCH_EXCEPTIONS_BY_TERM');

export const setInstallerTestExpectedActionTypes =
  makeActionTypes('SET_INSTALLER_TEST_EXPECTED');

export const verifyArtifactApplicationActionTypes =
  makeActionTypes('VERIFY_ARTIFACT_APPLICATION');

export const setMetricsByDateInfoTypes =
  makeActionTypes('SET_METRICS_BY_DATE_INFO');

export const toggleJenkinsBuildForeverActionTypes =
  makeActionTypes('TOGGLE_JENKINS_BUILD_FOREVER');

export const triggerJobActionTypes =
  makeActionTypes('TRIGGER_JOB');

export const updateCaseAmendingBaselineActionTypes =
  makeActionTypes('UPDATE_CASE_AMENDING_BASELINE');

export const updateJiraIssueDescriptionActionTypes =
  makeActionTypes('UPDATE_JIRA_DESCRIPTION');

export const updateUserConfigurationActionTypes =
  makeActionTypes('UPDATE_USER_CONFIGURATION');


// WEBPACK FOOTER //
// src/actions/types.js